import { TextField as TextFieldMUI, styled } from '@mui/material';
import React, { useState } from 'react';
import { themeOptions } from 'assets/styles/theme';

export const AUTO_GROW_MAX_ROWS = 10;

interface TextFieldProps {
  pattern?: RegExp;
  inputComponent?: any;
  error?: boolean;
  errorText?: string;
  shrink?: boolean;
  helperText?: string;
  maxLength?: number;
  label?: string;
  setValue: (value: string) => void;
  type?: string;
  defaultValue: string;
  isExtraAnnotation?: boolean;
  // Campo de texto livre: cresce com o conteudo e aceita quebra de linha (Enter)
  autoGrow?: boolean;
  variant?: string;
  readOnly?: boolean;
  sx?: object;
}

const StyledTextField = styled(TextFieldMUI)`
  width: 100%;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  input {
    &:invalid {
      color: ${themeOptions.palette.error.main};
    }
  }
`;

export default function TextField({
  pattern,
  inputComponent,
  shrink,
  error,
  errorText = '',
  helperText,
  maxLength,
  label = '',
  setValue,
  type = 'text',
  defaultValue,
  isExtraAnnotation,
  autoGrow,
  variant = 'outlined',
  readOnly,
  sx,
}: TextFieldProps) {
  const [errorMessage, setErrorMessage] = useState('');
  const baseRows = isExtraAnnotation ? 6 : 1;
  // rows fixo mantem o textarea travado na altura inicial (o \n entra, mas o
  // campo nao cresce e parece que o Enter nao funciona). minRows/maxRows ativa
  // o auto-resize do MUI, so para campos de texto livre.
  const rowProps = autoGrow
    ? { minRows: baseRows, maxRows: Math.max(baseRows, AUTO_GROW_MAX_ROWS) }
    : { rows: baseRows };
  const handleChangeValue = (value: string) => {
    if (value === ' ' || value === '') {
      setValue('');
    } else if (!pattern || value.match(pattern)) {
      setValue(value);
      setErrorMessage('');
    } else {
      setErrorMessage(errorText);
    }
  };

  return (
    <StyledTextField
      type={type}
      helperText={helperText}
      error={errorMessage.length !== 0}
      errorText={errorMessage}
      id="outlined-basic"
      label={label}
      variant={variant}
      value={defaultValue}
      sx={sx}
      multiline
      {...rowProps}
      onChange={(e: React.FormEvent<HTMLInputElement>) =>
        handleChangeValue(e.currentTarget.value)
      }
      InputProps={{
        pattern,
        shrink,
        maxLength,
        inputComponent,
        readOnly,
      }}
    />
  );
}
